import { HTMLAttributes } from 'react';
import { clsx } from 'clsx';
import { chipStyle } from './chip.css';

export const Chip = ({ className, ...rest }: HTMLAttributes<HTMLDivElement>) => (
  <div className={clsx(chipStyle, className)} {...rest} />
);
